// src/application.js
import 'intersection-observer'
import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import Turbolinks from 'turbolinks'
import 'lazysizes';
import Bugsnag from '@bugsnag/js'

window.bugsnag = Bugsnag('11df37c23c6f65c605ec1fec35bbd785')
window.Turbolinks = Turbolinks

const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))
Turbolinks.start();
